// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"275":"c9051490","576":"7e4665da"}[chunkId] + ".chunk.css";
};